/**
 * @file     productCopy.ts
 * @purpose  MessageRef catalog for product/feature marketing copy (Property Match name, description, start CTA).
 */
import { messageRef } from '../messageRef';

export const productCopy = {
  propertyMatch: {
    name: messageRef('dealFinder.page.title'),
    description: messageRef('dealFinder.page.description'),
    startAction: messageRef('ctas.primary.activateDealFinder'),
  },
} as const;
